import CategoryAPI from "./CategoryAPI";

const CategoryApiClient = new CategoryAPI();

export default CategoryApiClient;